import { createApp } from 'vue'

import UnitForm from '@/src/javascripts/settings/units/UnitForm.vue'
import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const unitForm = document.querySelector('#unit-form')
  if (unitForm && !unitForm.__vue_app__) {
    createApp({ components: { UnitForm, BaseAlert } }).mount(unitForm)
  }
})
